import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../../Components/Table/Table";
import { Button } from "../../Components/Button/Button";
import { Pagination, PaginationContent, PaginationItem, PaginationPrevious, PaginationLink, PaginationNext } from "../../Components/Pagination/Pagination";
import {
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  flexRender,
} from '@tanstack/react-table';
import { useMemo, useState } from "react";
import { ClipLoader } from 'react-spinners';
import { Input } from "../../Components/Input/Input";
import DistanceCalculator from '../../Components/DistanceCalculator/DistanceCalculator';
// import {
//   Select,
//   SelectGroup,
//   SelectValue,
//   SelectTrigger,
//   SelectContent,
//   SelectLabel,
//   SelectItem,
//   SelectSeparator,
// } from '../../Components/Select/Select';
// import * as SelectPrimitive from "@radix-ui/react-select";
// import { Check, ChevronDown, ChevronUp, EyeIcon, FilePenIcon } from "lucide-react";
import { useSelector } from 'react-redux';
import { Select } from '../../Components/Select/Select';
import { SelectTrigger } from '../../Components/Select/SelectTrigger';
import { SelectContent } from '../../Components/Select/SelectContent';
import { SelectItem } from '../../Components/Select/SelectItem';
// import { SelectSeparator } from '../../Components/Select/SelectSeparator';
// import { SelectLabel } from '../../Components/Select/SelectLabel';
import { SelectValue } from "../../Components/Select/SelectValue";
import Alert from "../../Components/Alert/Alert";
import { TrashIcon } from '../../Components/Icons/Icons';
import { useNavigate } from 'react-router-dom';


export function Users() {
  const [filter, setFilter] = useState('All');
  const queryClient = useQueryClient();
  const { darkMode } = useSelector((state) => state.darkMode);
  const [globalFilter, setGlobalFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15); // State for items per page
  const [deleteObject, setDeleteObject] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const navigate = useNavigate();

  const [isDeleting, setIsDeleting] = useState(false); 


  const columns = useMemo(
    () => [
      {
        id: 'userName',
        header: 'User Name',
        accessorKey: 'userName',
      },
      {
        id: 'profileName',
        header: 'Profile Name',
        accessorKey: 'profileName',
      },
      {
        id: 'email',
        header: 'Email',
        accessorKey: 'email',
      },
      {
        id: 'videos',
        header: 'Videos',
        accessorKey: 'videos',
        cell: ({ row }) => {
          return (
            <div className="flex items-center gap-2">
              <span>{row.original?.videos}</span> 
            </div>
          );
        },
      },
      {
        id: 'likes',
        header: 'Likes',
        accessorKey: 'likes',
      },
      {
        id: 'createdAt',
        header: 'Created At',
        accessorKey: 'createdAt',
        sortFn: (rowA, rowB) => {
          // Sort by date in descending order (newest first) by default
          return new Date(rowA.original.createdAt) - new Date(rowB.original.createdAt);
        },
        cell: ({ row }) => {
          const createdAtDate = new Date(row.original.createdAt).toLocaleDateString();
          return <span>{createdAtDate}</span>;
        },
      },
      {
        id: 'distance',
        header: 'Distance',
        accessorKey: 'distance',
        cell: ({ row }) => {
          const data = row.original?.distance;
      
          return (
            <div className="flex items-center gap-2 w-[150px] text-ellipsis overflow-hidden">
              {data ? (
                <DistanceCalculator targetCoordinates={data} />
              ) : (
                <span>No location data</span>
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  // const handleView = (row) => {
  //   console.log('View:', row.original);
  // };

  const handleEdit = (row) => {
    const updateUserData = {
      userId: row?.original?._id,
      "status": "active"
    }
    updateUserMutation.mutate(updateUserData);
  };

  const handleDelete = (row) => {
    // console.log("row", row.original)
    setDeleteObject(row.original)
    setAlertOpen(!alertOpen)
  };

  const deleteUserMutation = useMutation({
    mutationFn: async (userId) => {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/delete-user`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ userId: userId }),
      });
      if (response?.status == 401) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 400) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 500) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      } else {
        return response.json();
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['users', currentPage, itemsPerPage, filter]);
      setAlertOpen(false);
    },
    onError: (error) => {
      console.error('Error deleting user:', error.message);
    },
  });


  const updateUserMutation = useMutation({
    mutationFn: async (data) => {
      const token = localStorage.getItem('authToken');
      console.log("data.original", data._id)
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/update-status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }

      );
      if (response?.status == 401) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 400) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 500) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      } else {
        return response.json();
      }
    },
    onSuccess: (_, variables) => {
      queryClient.setQueryData(['userss', currentPage, itemsPerPage, filter], (oldData) => {
        if (!oldData?.message?.users?.docs) {
          return oldData;
        }

        return {
          ...oldData,
          message: {
            ...oldData.message,
            users: {
              ...oldData.message.users,
              docs: oldData.message.users.docs.map((user) =>
                user._id === variables.userId
                  ? { ...user, profileStatus: variables.status }
                  : user
              ),
            },
          },
        };
      });
      queryClient.invalidateQueries({ queryKey: ['userss'] });
      setAlertOpen(false);
    },
    onError: (error) => {
      console.error('Error deleting user:', error.message);
    },
  });
  const handleSuspend = (row) => {
    const updateUserData = {
      userId: row?.original?._id,
      "status": "suspended"
    }
    updateUserMutation.mutate(updateUserData);

  }


  const deleteUser = () => {
    if (deleteObject) {
      setIsDeleting(true); 
      deleteUserMutation.mutate(deleteObject._id);
      setIsDeleting(false);
    }
  }

  const { data, error, isLoading } = useQuery({
    queryKey: ['userss', currentPage, itemsPerPage, filter],
    queryFn: async () => {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/user/all?page=${currentPage}&limit=${itemsPerPage}&filter=${filter}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      if (response?.status == 401) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 400) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      }
      else if (response?.status == 500) {
        localStorage.removeItem("authToken");
        navigate(0)
        navigate("/login")
      } else {
        return response.json();
      }
    },
    keepPreviousData: true,

  });

  const tableData = useMemo(() => {
    console.log("user distance", data);
    if (data && data.success) {
      return data?.message?.users?.docs.map(user => ({
        _id: user._id,
        userName: user?.userName,
        email: user?.email,
        profileName: user?.profileName,
        videos: user?.videosCount, 
        likes: user?.likesCount,
        distance:user?.location?.coordinates,
        profileStatus: user?.profileStatus,
        createdAt:user?.createdAt,
      }));
    }
    return [];
  }, [data]);

  const totalEntries = data?.message?.users?.totalDocs || 0;
  const totalPages = data?.message?.users?.totalPages || 0;

  // Calculate the entries currently being shown
  const startEntry = (currentPage - 1) * itemsPerPage + 1;
  const endEntry = Math.min(currentPage * itemsPerPage, totalEntries);

  const table = useReactTable({
    data: tableData,

    columns,
    initialState: {
      sortBy: [{ id: 'createdAt', desc: true }], // Sort by createdAt descending initially
    },

    columns: useMemo(() => [
      ...columns,
      {
        id: 'actions',
        header: 'Actions',
        cell: ({ row }) => (

          <div className="flex items-center gap-2">
            {
              row?.original?.profileStatus === 'suspended' ? <Button onClick={() => handleEdit(row)} variant="ghost" className="bg-green-900 opacity:0.2 text-white hover:bg-green-400 hover:text-white" >
                <span>active</span>
              </Button> : <Button onClick={() => handleSuspend(row)} variant="ghost" className="bg-red-900 opacity:0.2 text-white hover:bg-red-400 hover:text-white" >

                <span > suspend</span>
              </Button>

            }


            <Button onClick={() => handleDelete(row)} variant="ghost" size="icon" className="text-red-500">
              <TrashIcon className="h-4 w-4" />
              <span className="sr-only">Delete</span>
            </Button>
          </div>
        ),
      }
    ], [columns]),
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    globalFilterFn: 'includesString',
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-svh">
        <ClipLoader color="#000000" loading={true} size={50} /> 
      </div>
    );
  }  
  if (error) return <div>Error loading users:    {error.message}</div>;

  const getPaginationRange = () => {
    const maxVisiblePages = 3;
    if (totalPages <= maxVisiblePages) {
      return [...Array(totalPages).keys()].map(i => i + 1);
    }
    const startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
    const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);
    const adjustedStartPage = Math.max(endPage - maxVisiblePages + 1, 1);
    const adjustedEndPage = Math.min(adjustedStartPage + maxVisiblePages - 1, totalPages);
    return [...Array(adjustedEndPage - adjustedStartPage + 1).keys()].map(i => i + adjustedStartPage);
  };

  const paginationRange = getPaginationRange();

  return (
    <div className="border rounded-lg m-2">
      {isDeleting ? (
        <div className="absolute z-50 flex justify-center items-center w-full h-full bg-opacity-50 bg-gray-900">
          <ClipLoader color="#ffffff" loading={true} size={50} />
        </div>
      ):
      (
        <div>
              <div className="flex justify-between items-center m-2">
          <Input
            type="search"
            placeholder="Search users..."
            value={globalFilter ?? ''}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full max-w-sm"
          />
  
          <div className={`w-full max-w-sm ${darkMode ? 'dark' : ""}`}>
            <Select onValueChange={setFilter} className="w-full">
              <SelectTrigger className="placeholder" placeholder="Select an option">
                <SelectValue value={filter} />
              </SelectTrigger>
              <div>
                <SelectContent className={`${darkMode ? 'dark' : ""}`}>
                  <SelectItem value='All'>All</SelectItem>
                  <SelectItem value='7 Days'>7 Days</SelectItem>
                  <SelectItem value='24 Hours'>24 Hours</SelectItem>
                </SelectContent>
              </div>
            </Select>
          </div>
  
          <div className={`w-full max-w-sm ${darkMode ? 'dark' : ""}`}>
            <Select onValueChange={setItemsPerPage} className="w-full">
              <SelectTrigger className="placeholder" placeholder="Select an option">
                <SelectValue value={itemsPerPage} />
              </SelectTrigger>
              <div>
                <SelectContent className={`${darkMode ? 'dark' : ""}`}>
                  <SelectItem value={10}>10</SelectItem>
                  <SelectItem value={15}>15</SelectItem>
                  <SelectItem value={20}>20</SelectItem>
                  <SelectItem value={25}>25</SelectItem>
                </SelectContent>
  
              </div>
            </Select>
          </div>
        </div>
        <Table>
          <TableHeader>
            <TableRow>
              {table.getHeaderGroups().map(headerGroup =>
                headerGroup.headers.map(header => (
                  <TableHead key={header.id}>
                    {header.isPlaceholder ? null : (
                      <div
                        {...{
                          onClick: header.column.getToggleSortingHandler(),
                          style: { cursor: 'pointer' },
                        }}
                      >
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {{
                          asc: ' 🔼',
                          desc: ' 🔽',
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    )}
                  </TableHead>
                ))
              )}
            </TableRow>
          </TableHeader>
          <TableBody>
            {table.getRowModel().rows.map((row) => (
              <TableRow key={row.id}>
                {row.getVisibleCells().map((cell) => (
                  <TableCell key={cell.id}>
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div className="border-t h-15 p-4 items-center flex justify-between  ">
          <div>
            <span className='text-sm text-muted-foreground dark:text-gray-200'>  Showing {startEntry} to {endEntry} of {totalEntries} entries </span>
          </div>
  
          <div>
            <Pagination>
              <PaginationContent>
                <PaginationItem>
                  <PaginationPrevious
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  />
                </PaginationItem>
                {paginationRange.map((page) => (
                  <PaginationItem key={page}>
                    <PaginationLink
                      onClick={() => {
                        if (page <= totalPages) {
                          setCurrentPage(page);
                        }
                      }}
                      isActive={currentPage === page}
                    >
                      {page}
                    </PaginationLink>
                  </PaginationItem>
                ))}
                <PaginationItem>
                  <PaginationNext
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                  />
                </PaginationItem>
              </PaginationContent>
            </Pagination>
          </div>
        </div>
        <Alert
          open={alertOpen}
          onOpenChange={setAlertOpen}
          title="Delete User"
          description="Are you sure you want to delete this user?"
          type="delete"
          onConfirm={deleteUser}
        />  
         </div>
      )
      }
  
      </div>
    );
}
